var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"zelan-order scroll-view"},[_c('Navigation',{attrs:{"title":"Order"}}),_c('div',{staticClass:"zelan-order__body"}),_c('OpenApp',{attrs:{"bottom":50}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }